import type { PortfolioItem } from "@pokifolio/contracts";

import { GRADING_COMPANY_LABELS, RAW_CONDITION_LABELS } from "../research/format";

/** "PSA 10", "Near mint", or "Raw" when no condition was recorded. */
export function describeCondition(item: PortfolioItem): string {
  if (item.cardType === "graded" && item.gradingCompany !== null) {
    return `${GRADING_COMPANY_LABELS[item.gradingCompany]} ${String(item.grade ?? "")}`.trim();
  }
  return item.condition === null ? "Raw" : RAW_CONDITION_LABELS[item.condition];
}

/** "Base Set · 4/102" (whatever is known). */
export function describeSet(item: PortfolioItem): string {
  return [item.setName, item.cardNumber].filter((v) => v !== null).join(" · ");
}
